// for prod
// caution! change endpoint after api deploy
const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "WeConnect",
            "endpoint": "https://wy1yytjr33.execute-api.ap-northeast-1.amazonaws.com/weconnect",
            "region": "ap-northeast-1"
        }
    ]
};


export default awsmobile;
